import { Link } from 'react-router-dom'

import { AuthScreenLayout } from '../components/auth/AuthScreenLayout'
import { LegalDocumentBody } from '../legal/content/LegalDocumentBody'
import { publicOfferSections } from '../legal/content/publicOffer'
import {
  PUBLIC_OFFER_DOCUMENT_VERSION,
  PUBLIC_OFFER_EXTERNAL_URL,
} from '../legal/publicOffer'

/**
 * Оферта целиком, а не ссылкой: на неё ссылается акцепт при регистрации, и текст должен быть
 * доступен там же, где происходит согласие. Источник — тот же markdown, что и на лендинге.
 */
export const PublicOfferLegalScreen = () => (
  <AuthScreenLayout variant="register">
    <article className="market-auth__card market-auth__card--register market-legal-doc">
      <header className="market-auth__card-header market-auth__card-header--compact">
        <h1 className="market-auth__card-title market-auth__card-title--compact">
          Публичная оферта
        </h1>
        <p className="market-auth__card-lead market-auth__card-lead--compact">
          Редакция {PUBLIC_OFFER_DOCUMENT_VERSION}. Постоянный адрес:{' '}
          <a href={PUBLIC_OFFER_EXTERNAL_URL} target="_blank" rel="noreferrer">
            provisium.ru/offer
          </a>
        </p>
      </header>

      <div className="market-legal-doc__body">
        <LegalDocumentBody sections={publicOfferSections} />
      </div>

      <p className="market-legal-doc__back">
        <Link className="market-auth__signup-link" to="/register">
          ← Вернуться к регистрации
        </Link>
      </p>
    </article>
  </AuthScreenLayout>
)
